import http from './http.service';

class LocationService {
    constructor() {
        if (LocationService.instance) {
            return LocationService.instance;
        }

        LocationService.instance = this;
    }

    locations() {
        return http.get('/location').then(res => res.data);
    }
    store(data) {
        return http.post('/location/store', data).then(res => res.data);
    }
    update(locationId, data) {
        return http.put(`/location/${locationId}/update`, data).then(res => res.data);
    }
    destroy(locationId) {
        return http.delete(`/location/${locationId}/destroy`).then(res => res.data);
    }
}

export default new LocationService();
